import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "19",
  viewBox: "0 0 20 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.8708 7.77L19.1167 0H17.2667L11.0383 6.66L6.16667 0H0L7.585 10.36L0 18.5H1.85L8.4175 11.47L13.5667 18.5H19.7333L11.8708 7.77ZM2.74417 1.23333H5.21083L16.9583 17.2667H14.4917L2.74417 1.23333Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }